import consentManagementModule from './consentManagement';
import priceFloorsModule from './priceFloors';
import {applyPlaceholders} from '../../utils/placeholder';
import storage from '../../utils/storage';
import {getRandomizedUserId, getUserId} from "../../services/userService";

export function getPlaceholders(): Record<string, string> {
	return {
		'PWID': storage.getFromCookie('authId'),
		'domain': window.location.hostname,
		'pageUrl': `${window.location.origin}${window.location.pathname}`,
		'userId': getUserId(),
		'randomizedUserId': getRandomizedUserId()
	};
}

export function getModuleConfig(config: PrebidConfig) {
	const prebidModuleConfig: AnyObject = JSON.parse(JSON.stringify(config.additionalConfig ?? {}));

	consentManagementModule.apply(prebidModuleConfig, config);
	priceFloorsModule.apply(prebidModuleConfig);

	return applyPlaceholders(prebidModuleConfig, getPlaceholders());
}

type BidderConfig = {
	bidders: Array<string>
	config: AnyObject
};

export function getBidderModuleConfigs(config: PrebidConfig) {
	const additionalBidderConfigs = JSON.parse(JSON.stringify(config.additionalBidderConfigs ?? [])),
		placeholders = getPlaceholders();

	return additionalBidderConfigs.map((bidderConfig: BidderConfig) => {
		return applyPlaceholders(bidderConfig, placeholders);
	});
}

export function getBidderSettingsConfigs(config: PrebidConfig) {
	const bidderSettings = JSON.parse(JSON.stringify(config.bidderSettings ?? {})),
		placeholders = getPlaceholders();

	return applyPlaceholders(bidderSettings, placeholders);
}


export default {
	getPlaceholders,
	getModuleConfig,
	getBidderModuleConfigs,
	getBidderSettingsConfigs
};
